import React from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Stack,
  alpha,
  useTheme,
} from '@mui/material';
import {
  Instagram,
  LinkedIn,
  Facebook,
  Language,
  WhatsApp,
  Close,
} from '@mui/icons-material';
import { ReactComponent as Twitter } from '../../../../assets/images/twitter.svg';

const SocialLinksDialog = ({ open, onClose, links }) => {
  const theme = useTheme();

  const whatsappUrl = links?.whatsapp
    ? links.whatsapp.startsWith('http')
      ? links.whatsapp
      : `https://wa.me/${links.whatsapp.replace(/[^\d+]/g, '')}`
    : undefined;

  const items = [
    { key: 'facebook', icon: <Facebook />, label: 'Facebook', color: '#1877F2', url: links?.facebook },
    { key: 'instagram', icon: <Instagram />, label: 'Instagram', color: '#E4405F', url: links?.instagram },
    { key: 'x', icon: <Twitter />, label: 'X', color: '#000000', url: links?.x },
    { key: 'linkedin', icon: <LinkedIn />, label: 'LinkedIn', color: '#0A66C2', url: links?.linkedin },
    { key: 'website', icon: <Language />, label: 'Website', color: '#712d94', url: links?.website },
    { key: 'whatsapp', icon: <WhatsApp />, label: 'WhatsApp', color: '#25D366', url: whatsappUrl },
  ].filter((item) => item.url);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogContent sx={{ p: { xs: 2.5, sm: 3 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: theme.palette.text.primary,
              fontSize: { xs: '1.25rem', sm: '1.5rem' },
              position: 'relative',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: -8,
                left: 0,
                width: 40,
                height: 3,
                backgroundColor: theme.palette.primary.main,
                borderRadius: 2,
              },
            }}
          >
            My social links
          </Typography>
          <IconButton size="small" onClick={onClose} aria-label="Close">
            <Close fontSize="small" />
          </IconButton>
        </Box>

        <Stack spacing={1} sx={{ mt: 3 }}>
          {items.map((link) => (
            <a
              key={link.key}
              href={link.url.match(/^https?:\/\//) ? link.url : `//${link.url}`}
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: 'none' }}
              onClick={(e) => e.stopPropagation()}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  p: 1.5,
                  borderRadius: 2,
                  border: `1px solid ${theme.palette.divider}`,
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    transform: 'translateY(-1px)',
                    boxShadow: `0 4px 12px ${alpha(theme.palette.common.black, 0.1)}`,
                  },
                  cursor: 'pointer',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 36,
                    height: 36,
                    borderRadius: 1,
                    backgroundColor: alpha(link.color, 0.1),
                    color: link.color,
                    flexShrink: 0,
                    '& svg': { fontSize: '1.25rem' },
                  }}
                >
                  {link.icon}
                </Box>
                <Typography
                  variant="body2"
                  sx={{ color: theme.palette.text.primary, fontWeight: 500, fontSize: '0.95rem' }}
                >
                  {link.label}
                </Typography>
              </Box>
            </a>
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default SocialLinksDialog;
